import React from 'react';
import { useAtomValue } from 'jotai';
import { selectedMetricsAtom, anchorMetricsAtom } from './atoms';
import UserSessionsDropmenu from './Dropdown';
import { getMandatoryDimensions } from './utils';
import { useSelector } from 'react-redux';
import { getUserProfile } from '@src/store/common/selectors';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';

function AppViewerControls() {
  const anchoredMetrics = useAtomValue(anchorMetricsAtom);
  const exceedTimeLimit = false;
  const selectedMetrics = useAtomValue(selectedMetricsAtom);
  const { customer_id } = useSelector(getUserProfile);
  const selectedMetricCardMetric: any = useSelector(selectedMetricSelector);
  const mandatoryDimensions = getMandatoryDimensions(customer_id, selectedMetricCardMetric);

  return (
    <UserSessionsDropmenu
      selectedMetrics={selectedMetrics}
      anchoredMetrics={anchoredMetrics}
      exceedTimeLimit={exceedTimeLimit}
      mandatoryDimensions={mandatoryDimensions}
    />
  );
}

export default AppViewerControls;
